/*
 * File: WimsicalError.tsx
 * Project: beaker
 * -----
 * Last Modified: 27 Apr 2022 4:30:07 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import React, { FC } from 'react';
import './wimsicalError.css';

interface WimsicalErrorProps {
  title: string;
  statusCode?: string | number;
  redirectUrl?: string;
  subTitle?: string;
  redirectText?: string;
}

const WimsicalError: FC<WimsicalErrorProps> = ({ title, statusCode, redirectText, redirectUrl, subTitle }: WimsicalErrorProps) => {
  const redirectJSX = redirectUrl ? (
    <a href={redirectUrl} className="link_404">
      {redirectText}
    </a>
  ) : null;

  return (
    <section className="page_404">
      <div className="four_zero_four_bg">
        <h1 className="text-center ">{statusCode}</h1>
      </div>
      <div className="contant_box_404">
        <h3 className="h2">{title}</h3>
        <p>{subTitle}</p>
        {redirectJSX}
      </div>
    </section>
  );
};

export default WimsicalError;
